import { OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarService } from '@ibe/services/ui';
import * as fromStore from '@ibe/store/index';
import { Store } from '@ngrx/store';
import { takeWhile, map } from 'rxjs/operators';
import { INDRAMilesService } from '@ibe.services/miles.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { DISCOUNT_STATUS_ACTIVE } from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
var INDRATotalAmountSummaryComponent = /** @class */ (function () {
    function INDRATotalAmountSummaryComponent(store, router, sidebarService, milesService, currencyService, flightPriceService, storage, paymentService, bfmStorage, ibeAdminConfigService) {
        var _this = this;
        this.store = store;
        this.router = router;
        this.sidebarService = sidebarService;
        this.milesService = milesService;
        this.currencyService = currencyService;
        this.flightPriceService = flightPriceService;
        this.storage = storage;
        this.paymentService = paymentService;
        this.bfmStorage = bfmStorage;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this.userInfo$ = this.store.select(fromStore.getUserInfo);
        this.bookedTripDiscounts$ = this.store.select(fromStore.getSelectedBookedTripDiscounts);
        this.bookedTripDiscounts = [];
        this.milesInFlightDiscount$ = this.store.select(fromStore.getMilesInFlightDiscount);
        this.processAncillary$ = this.store.select(fromStore.getProcessAncillary);
        this.promoCodesAndVoucher$ = this.store.select(fromStore.getSelectedPromoVouchers);
        this.promoCodesAndVoucher = [];
        this.loading$ = this.store.select(fromStore.getAncillaryToPayWithMilesLoading);
        this.bookAwardFlights$ = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
        this.isCorporate = false;
        this.isAlive = true;
        this.title = 'Total amount';
        this.showTaxes = true;
        this.isDupe = false;
        this.isTTTBookingForCompletion = false;
        this.isTTTBookingView = false;
        this.isBookingView = false;
        this.displayPrice = false; // to display price param
        this.isTaxSidebarByPNR = true; // display link for taxes sidebar using PNR
        this.isBookingAreadyCreated = false;
        this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
        this.userInfo$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (user) {
            _this.isUserLoggedIn = user;
            _this.userMiles = user && user['currentPoints'] ? user['currentPoints'] : 0;
        });
        // get booking total price object 
        this.paymentService.totalFlightPrice
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (totalFlightPrice) {
            _this.totalFlightPrice = totalFlightPrice;
        });
        this.bookAwardFlights$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.bookAwardFlights = value;
        });
        this.bookedTripDiscounts$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (discounts) {
            _this.bookedTripDiscounts = Object.assign([], discounts);
        });
        this.milesInFlightDiscount$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.milesInFlightDiscount = value;
        });
        this.promoCodesAndVoucher$
            .pipe(takeWhile(function () { return _this.isAlive; }), map(function (value) { return value && value.filter(function (discount) { return discount.status === DISCOUNT_STATUS_ACTIVE; }); }))
            .subscribe(function (discount) {
            if (discount && discount.length > 0) {
                _this.promoCodesAndVoucher = discount;
            }
            else {
                _this.promoCodesAndVoucher = [];
            }
        });
        // TODO check the purpose of this and if it can be removed
        this.processAncillary$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            var ancillaryList = _this.storage.get('INDRAAncillariesShoppingCartService.shoppingCart');
            var ancillaryPrice = _this.flightPriceService.INDRA_getAncillariesPaidWithMiles(ancillaryList);
            _this.store.dispatch(new AncillariesWithMilesActions.PutAncillaryTotalToPayAction(ancillaryPrice ? ancillaryPrice : null));
        });
    }
    Object.defineProperty(INDRATotalAmountSummaryComponent.prototype, "price", {
        set: function (val) {
            this.totalPrice = val;
        },
        enumerable: true,
        configurable: true
    });
    INDRATotalAmountSummaryComponent.prototype.ngOnInit = function () { };
    INDRATotalAmountSummaryComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRATotalAmountSummaryComponent.prototype.INDRA_formatMiles = function (value) {
        return value + ' M';
    };
    INDRATotalAmountSummaryComponent.prototype.INDRA_formatCash = function (value) {
        return parseFloat(value.toFixed(2)) + ' ' + this.currency;
    };
    INDRATotalAmountSummaryComponent.prototype.INDRA_printMiles = function () {
        if (this.isDupe || this.displayPrice || this.userMiles < 0)
            return null;
        return this.INDRA_getPriceComponent('miles');
    };
    INDRATotalAmountSummaryComponent.prototype.INDRA_printOriginalPrice = function () { };
    INDRATotalAmountSummaryComponent.prototype.INDRA_printFinalPrice = function () {
        if (this.isDupe || this.displayPrice) {
            return this.totalPrice;
        }
        else {
            return this.INDRA_getPriceComponent('cash');
        }
    };
    INDRATotalAmountSummaryComponent.prototype.INDRA_getPriceComponent = function (priceComponent) {
        if (this.router.url.includes('payment') || this.promoCodesAndVoucher.length > 0 || this.bookAwardFlights) {
            var price = void 0;
            switch (priceComponent) {
                case 'cash':
                    price = this.totalFlightPrice && this.totalFlightPrice.cash ?
                        parseFloat(this.totalFlightPrice.cash.toFixed(2)) + ' ' +
                            this.currencyService.INDRA_getCurrencySymbol(this.totalFlightPrice.currency).unit :
                        0 + ' ' + this.currency;
                    break;
                case 'miles':
                    price = this.totalFlightPrice && this.totalFlightPrice.miles ?
                        this.INDRA_formatMiles(this.totalFlightPrice.miles) : null;
                    break;
            }
            return price;
        }
        else {
            // possibiliy of mgp1 price override is only applicable to booking without promocodes or voucher, 
            // not an award flight, AND while on review page
            //const booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
            var currency = this.currencyService.INDRA_getCurrencySymbol(this.totalFlightPrice.currency).unit;
            var miles = this.totalFlightPrice.miles && this.totalFlightPrice.miles > 0 ? this.totalFlightPrice.miles : 0;
            var cash = this.totalFlightPrice.cash ? this.totalFlightPrice.cash : 0;
            //let milesAllowanceConfig = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.initialMilesAllowance');
            //let initialMilesAllowance: number = milesAllowanceConfig && !isNaN(parseFloat(milesAllowanceConfig)) ? -(Number(milesAllowanceConfig)) : -1800;
            //let deficitMiles = this.isUserLoggedIn ? this.userMiles - miles : miles;
            //let milesAllowance = this.bookAwardFlights ? 0 : initialMilesAllowance;
            /*if (this.isUserLoggedIn && deficitMiles < milesAllowance) {
                cash = booked_trip.data.fare.bookingTotal.amount;
                miles = 0;
            }
            else {
                // Override prices from API if has mgp1 discount AND mgp1 == flight milesgo discount in store (and no promocode/voucher) AND bookingTotal.miles from API is NULL or 0.
                // Note that we are also considering if there are ancillaries paid with miles (bookingTotal.miles from API is NOT NULL and NOT 0 -- this is the else if below)
                // but still does not include the mgp1 miles discount (we are using the condition initialMGDiscount === cashDiscountEquivalentOfMilesDiscount
                // to determine that mgp1 is applied in front AND miles - milesInFlightDiscount > 0 to determine that there is ancillaries being paid by miles)
                const initialMGDiscount =
                    this.bookedTripDiscounts && this.bookedTripDiscounts.length > 0 && this.bookedTripDiscounts[0] && this.bookedTripDiscounts[0].value ?
                        this.bookedTripDiscounts[0].value : 0;
                const milesInFlightDiscount = this.milesInFlightDiscount && this.milesInFlightDiscount.miles ? this.milesInFlightDiscount.miles : 0;
                const cashDiscountEquivalentOfMilesDiscount = this.milesInFlightDiscount && this.milesInFlightDiscount.cash ? this.milesInFlightDiscount.cash : 0;
                if (miles == 0 && (initialMGDiscount > 0 && cashDiscountEquivalentOfMilesDiscount > 0 && initialMGDiscount === cashDiscountEquivalentOfMilesDiscount)) {
                    miles = milesInFlightDiscount;
                    cash = cash - initialMGDiscount;
                } else if (miles > 0 && (miles - milesInFlightDiscount) > 0 &&
                    (initialMGDiscount > 0 && cashDiscountEquivalentOfMilesDiscount > 0 && initialMGDiscount === cashDiscountEquivalentOfMilesDiscount)) {
                    miles += milesInFlightDiscount;
                    cash = cash - initialMGDiscount;
                }
            }*/
            var price = void 0;
            switch (priceComponent) {
                case 'cash':
                    price = cash.toFixed(2) + " " + currency;
                    break;
                case 'miles':
                    price = miles > 0 ? miles.toFixed(0) + " M" : null;
                    break;
            }
            return price;
        }
    };
    INDRATotalAmountSummaryComponent.prototype.INDRA_handleTaxesAndCharges = function () {
        var fareTaxesParams = {
            isDupe: this.isDupe,
            isTTTBookingForCompletion: this.isTTTBookingForCompletion
        };
        if (this.isTaxSidebarByPNR && !this.isDupe && (this.isTTTBookingForCompletion || this.isBookingView)) {
            fareTaxesParams['pnr'] = this.pnr;
        }
        this.sidebarService.openSidebar(['fare-and-taxes', fareTaxesParams]);
    };
    INDRATotalAmountSummaryComponent.prototype.INDRA_handlePriceBreakdown = function () {
        if (this.isTTTBookingView) {
            this.sidebarService.openSidebar(['price-breakdown-ttt']);
        }
        else {
            if (this.isBookingView) {
                var priceBreakdownParam = {
                    pnr: this.pnr
                };
                if (!this.isTaxSidebarByPNR) {
                    priceBreakdownParam['isTaxSidebarByPNR'] = false;
                }
                this.sidebarService.openSidebar(['booking-price-breakdown-view', priceBreakdownParam]);
            }
            else {
                this.sidebarService.openSidebar(['booking-price-breakdown-new',
                    {
                        isDupe: this.isDupe,
                        isTTTBookingForCompletion: this.isTTTBookingForCompletion,
                        isBookingCreated: this.isBookingAreadyCreated
                    }
                ]);
            }
        }
    };
    return INDRATotalAmountSummaryComponent;
}());
export { INDRATotalAmountSummaryComponent };
